import React from 'react';
import { Box, Typography } from '@mui/material';

import { useFormatDateAndTime } from '../Hooks/useFormatDateAndTime';

const DeliveryDateAndTime = ({orderDetails}) => {
  const { FormatTimeForDisplay, FormatLongDateForDisplay } = useFormatDateAndTime();

  // Format Delivery Date and Time (if set).
  const deliveryDateFormatted = orderDetails.deliveryDate
    ? FormatLongDateForDisplay(orderDetails.deliveryDate)
    : '';

  const deliveryTimeFormatted = orderDetails.deliveryTime
    ? FormatTimeForDisplay(orderDetails.deliveryTime)
    : '';

  return (
    <div className='condensed-content'>
      <Box sx={{ pt: '20px' }}>
        {deliveryDateFormatted ? (
          <>
            <Typography variant='h3' component='h3'>
              Delivery Date
            </Typography>
            <Typography>{deliveryDateFormatted}</Typography>
          </>
        ) : null}
        {deliveryTimeFormatted ? (
          <>
            <Typography variant='h3' component='h3' sx={{ pt: '10px' }}>
              Delivery Time
            </Typography>
            <Typography>{deliveryTimeFormatted}</Typography>
          </>
        ) : null}
      </Box>
    </div>
  );
};

export default DeliveryDateAndTime;
